module.exports = __webpack_public_path__ + "img/openagent-logo-mono.13878383.png";